// src/util/toast-service.js
import toast from "react-hot-toast";

let currentToastId = null;

export const showToast = (message, type = "success") => {
  currentToastId = toast[type]?.(message);
};

export const hideToast = () => {
  if (currentToastId !== null) {
    toast.remove(currentToastId);
    currentToastId = null;
  }
};